/* eslint-disable complexity */
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { statusReport007 } from '@src/slide/infrastructure/module/dependent/report/real-time-report/real-time';
import {
    Reporter007,
    Reporter007ActionType,
} from '@src/slide/infrastructure/module/dependent/report/real-time-report/constant';
import eventBus, { EventKeys } from '@src/slide/infrastructure/module/independent/event-emitter/instance';

export default class WhiteScreenCollector {
    public static instance: WhiteScreenCollector;
    public static getInstance(): WhiteScreenCollector {
        if (!WhiteScreenCollector.instance) {
            WhiteScreenCollector.instance = new WhiteScreenCollector();
        }
        return WhiteScreenCollector.instance;
    }

    private firstPageDisplay = false;
    private dataReady = false;

    public startWhiteScreenMonitor = (): void => {
        eventBus.once(EventKeys.FIRST_PAGE_DISPLAY, () => {
            this.firstPageDisplay = true;
        });
        eventBus.once(EventKeys.SLIDE_APP_READY, () => {
            this.dataReady = true;
        });

        global.addEventListener('beforeunload', () => {
            const readable = window.clientVars?.privilegeAttribute?.can_read;
            const showBlankPage = !readable;
            console.log('beforeunload', this.firstPageDisplay, showBlankPage);
            const performance = (global && (global.performance
                || global.webkitPerformance
                || global.msPerformance))
                || {};
            // 计算白屏时间, 如果数据还在加载中，也上报
            if (!this.firstPageDisplay && (!showBlankPage || !this.dataReady)) {
                if (performance?.timing) {
                    const { timing } = performance;
                    if (timing.requestStart) {
                        const { requestStart } = timing;
                        const whiteScreenTime = (new Date()).getTime() - requestStart;
                        console.log('whiteScreenTime=', whiteScreenTime, this.dataReady);
                        global.log?.info(`whiteScreenTime=${whiteScreenTime},dataReady=${this.dataReady}`);
                        tdw({
                            opername: 'ppt_performance',
                            module: 'detail',
                            action: 'white_screen',
                            ver5: 0,
                            ver6: JSON.stringify({
                                whiteScreenTime,
                                dataReady: this.dataReady,
                            }),
                        });
                        statusReport007(Reporter007ActionType.WHITE_SCREEN, Reporter007.SUCCESS);
                    }
                }
            }
        });
    };
}
